.header { display: flex; align-items: flex-end; justify-content: space-between; gap: 28px; }
.headerRight { display: flex; flex-direction: column; align-items: flex-end; gap: 16px; }
.sticker { padding: 8px 14px; background: var(--amber); border: 2px solid var(--ink); font-family: var(--font-cond); font-size: 18px; font-weight: 900; }
.controls { display: flex; align-items: center; gap: 14px; }
.filter { padding: 10px 16px; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; }
.addWrap { position: relative; }
.popover { position: absolute; right: 0; top: calc(100% + 8px); z-index: 10; width: 280px; transform-origin: top right; }
.popover:focus { outline: none; }
.menu { display: flex; flex-direction: column; background: var(--paper); border: var(--border-panel); box-shadow: 5px 5px 0 var(--ink); }
.menuItem { display: flex; align-items: center; gap: 12px; padding: 14px 16px; text-align: left; background: var(--paper); border-bottom: var(--border-hair); }
.menuItem:last-child { border-bottom: 0; }
.menuItem[data-tone='pink'] { background: var(--pink); }
.menuText { display: flex; flex-direction: column; gap: 3px; }
.menuTitle { font-family: var(--font-mono); font-size: 11px; letter-spacing: 1px; }
.menuSub { font-size: 12px; }
.sheetHead, .sheetCancel, .menuChevron, .legend, .key, .meta { display: none; }
.syncNote { position: absolute; right: 0; top: calc(100% + 8px); margin: 0; white-space: nowrap; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--text-secondary); }
.tablePanel { background: var(--paper); border: var(--border-panel); }
/* Two classes: .dark-head's gap loads after this module; this header had none. */
.tablePanel > :global(.dark-head) { gap: 0; }
.darkNote { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--pink); }
.table th:first-child, .table td:first-child { padding-left: 22px; width: 90px; }
.table th:nth-child(2), .table td:nth-child(2) { width: 130px; }
.table th:nth-child(4), .table td:nth-child(4), .table th:nth-child(5), .table td:nth-child(5) { width: 100px; }
.table th:nth-child(6), .table td:nth-child(6) { width: 140px; }
.table th:nth-child(7), .table td:nth-child(7) { width: 90px; }
.table th:nth-child(8), .table td:nth-child(8) { width: 170px; }
.table th:last-child, .table td:last-child { width: 80px; padding-right: 22px; }
.table tr[data-status='failed'] td { background: var(--hot-8); }
.name { font-family: var(--font-cond); font-size: 20px; font-weight: 800; overflow-wrap: anywhere; }
.nameRow > [role='img'] { margin-left: 6px; vertical-align: middle; }
.subType { margin-left: 6px; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--text-secondary); vertical-align: middle; }
.phoneBadge { display: none; }
.filtersScroll { display: flex; }
.filter { display: inline-flex; align-items: center; gap: 6px; }
.swatch { display: inline-block; width: 8px; height: 8px; border: 1px solid var(--ink); }
/* The active tab is ink, so its swatch takes a paper rim. */
.filter[aria-current='page'] .swatch { border: 1px solid var(--paper); }
.rowError { display: block; margin-top: 4px; font-family: var(--font-sans); font-size: 12px; color: var(--hot); }
.table td.source { font-size: 10px; letter-spacing: 1px; color: var(--text-secondary); }
.retryError { margin: 0; padding: 12px 22px; background: var(--hot-8); border-bottom: var(--border-hair); font-family: var(--font-sans); font-size: 13px; color: var(--hot); }
.footer { display: flex; align-items: center; justify-content: space-between; padding: 16px 22px; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--text-secondary); }

@media (max-width: 1023px) {
  .header { flex-wrap: wrap; }
  .headerRight { align-items: flex-start; }
}

@media (min-width: 640px) and (max-width: 1023px) {
  .table th:nth-child(5), .table td:nth-child(5), .table th:nth-child(6), .table td:nth-child(6), .table th:nth-child(9), .table td:nth-child(9) { display: none; }
  .table th:first-child, .table td:first-child { padding-left: 16px; width: 84px; }
  .table th:nth-child(2), .table td:nth-child(2) { width: 74px; }
  .table th:nth-child(4), .table td:nth-child(4) { width: 88px; }
  .table th:nth-child(7), .table td:nth-child(7) { width: 90px; }
  .table th:nth-child(8), .table td:nth-child(8) { width: 150px; padding-right: 16px; }
  /* Two classes: global.css loads after this module, so a lone .darkHead would lose to .dark-head's padding. */
  .tablePanel > :global(.dark-head), .footer { padding-left: 16px; padding-right: 16px; }
}

@media (max-width: 639px) {
  /* Two classes: global.css loads after this module and its .page gap is 24px. */
  .page:global(.page) { gap: 20px; }
  /* nowrap: a wrapping column's line is as wide as its widest item, so the sport filter would widen the page. */
  .header { flex-direction: column; flex-wrap: nowrap; align-items: stretch; gap: 8px; }
  .headerRight { display: contents; }
  .sticker { align-self: flex-start; padding: 6px 12px; font-size: 16px; }
  .controls { height: 48px; margin-top: 12px; gap: 8px; }
  .filtersScroll { flex: 1; min-width: 0; height: 100%; overflow-x: auto; scrollbar-width: none; }
  .filters { flex: none; height: 100%; }
  .filter { flex: none; justify-content: center; padding: 0 12px; letter-spacing: 0.6px; }
  /* Two classes: global.css loads after this module, so a lone .addButton would lose to .btn's padding and font. */
  .addWrap > .addButton { padding: 0 14px; gap: 6px; font-size: 11px; }

  .popover { position: static; width: auto; display: flex; flex-direction: column; gap: 12px; padding-bottom: 16px; }
  .sheetHead { display: flex; align-items: flex-start; justify-content: space-between; }
  .sheetText { display: flex; flex-direction: column; gap: 2px; }
  .sheetEyebrow { margin: 0; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.4px; color: var(--hot); }
  .sheetTitle { margin: 0; font-family: var(--font-cond); font-size: 30px; font-weight: 900; letter-spacing: -1px; line-height: 1; }
  .menu { box-shadow: 4px 4px 0 var(--ink); }
  .menuItem { width: 100%; height: 68px; padding: 0 16px; gap: 14px; }
  .menuItem > svg:first-child { width: 18px; height: 18px; }
  .menuText { flex: 1; min-width: 0; }
  .menuTitle { font-size: 12px; }
  .menuSub { font-size: 13px; }
  .menuChevron { display: block; flex: none; }
  .sheetCancel { display: flex; align-items: center; justify-content: center; height: 52px; border: var(--border-control); font-family: var(--font-mono); font-size: 12px; letter-spacing: 1.2px; }

  .retryError { padding: 12px 16px; }
  .table tr { position: relative; display: grid; grid-template-columns: auto minmax(0, 1fr) 56px; grid-template-areas: 'sport date load' 'name name load'; column-gap: 8px; row-gap: 5px; padding: 12px 16px; border-bottom: var(--border-hair); }
  .table tr:nth-child(even) { background: var(--paper-2); }
  .table tr[data-status='failed'] { background: var(--hot-8); }
  .table tr[data-status='failed'] td { background: transparent; }
  .table td[data-cell] { width: auto; min-width: 0; padding: 0; border: 0; }
  .table td[data-cell='date'] { grid-area: date; align-self: center; font-size: 10px; letter-spacing: 0.6px; color: var(--text-secondary); }
  .table td[data-cell='sport'] { grid-area: sport; }
  .table td[data-cell='name'] { grid-area: name; display: flex; flex-direction: column; gap: 5px; align-items: flex-start; }
  .table td[data-cell='load'] { grid-area: load; align-self: center; }
  .table td[data-cell='duration'], .table td[data-cell='distance'], .table td[data-cell='metric'], .table td[data-cell='how'], .table td[data-cell='source'] { display: none; }
  .subType { display: none; }
  .phoneBadge { display: block; }
  .name { font-size: 19px; }
  .name::after { content: ''; position: absolute; inset: 0; }
  .meta { display: block; letter-spacing: 0.4px; color: var(--text-secondary); font-size: 10px; }
  .rowError { font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.8px; }
  .loadCell { display: flex; justify-content: flex-end; }
  .loadCell > [data-part='load'] { display: flex; flex-direction: column-reverse; align-items: flex-end; gap: 4px; font-family: var(--font-cond); font-size: 24px; font-weight: 900; line-height: 1; }
  .loadCell > [data-part='load'] > span { height: 6px; max-width: 72px; }
  .loadCell button { position: relative; z-index: 1; }

  .footer { flex-direction: column; align-items: stretch; gap: 10px; padding: 14px 16px; }
  .legend { display: flex; align-items: center; gap: 16px; font-size: 9px; letter-spacing: 1px; }
  .legendItem { display: inline-flex; align-items: center; gap: 8px; }
  .key { display: block; font-size: 9px; letter-spacing: 0.6px; }
  .count { letter-spacing: 1.2px; }
  .more { width: 100%; font-size: 11px; letter-spacing: 1px; }
}
